<template>
  <main
    class="max-w-[1200px] w-[60vw] min-w-[768px] max-md:min-w-[88vw] mx-auto mb-20 flex-1"
  >
    <h1 class="font-bold text-center my-8">마이페이지</h1>
    <!-- <h3 class="nanum-square max-md:px-4"><b>{{$store.state.uid.id}}</b>님 안녕하세요.</h3> -->
    <div class="max-md:px-5">
      <div
        class="flex flex-col justify-between bg-neutral-100 border rounded-lg border-neutral-200 p-5 mt-4 max-md:flex-col max-md:gap-4 max-md:items-center"
      >
        <!-- <div class="flex gap-[5vw] max-md:grid max-md:w-full">
          <div>
            <p>캐시</p>
            <div class="flex items-center">
              <b class="text-[#FF4A4A] font-bold text-3xl">0</b>
              <button type="button" class="ml-2 border border-black rounded px-1 text-sm">충전</button>
            </div>
          </div>
          <div>
            <p>포인트</p>
            <b class="text-[#FF4A4A] font-bold text-3xl">0</b>
          </div>
          <div>
            <p>쿠폰</p>
            <b class="text-[#FF4A4A] font-bold text-3xl">0</b>
          </div>
        </div> -->
        <h3 class="nanum-square max-md:px-4">
          <b>{{ $store.state.uid.id }}</b
          >님 안녕하세요.
        </h3>
        <div class="flex gap-2 items-center place-self-end max-md:m-auto">
          <VDialog no-scroll :classes="{ bg: 'bg-black-alpha' }">
            <template #toggle="{ bind, on }">
              <button
                v-bind="bind"
                v-on="on"
                class="inline-flex h-fit gap-1 bg-white border border-black p-2 items-center text-sm"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12.0808 4.10666C12.3083 3.87916 12.3083 3.49999 12.0808 3.28416L10.7158 1.91916C10.5 1.69166 10.1208 1.69166 9.89333 1.91916L8.82 2.98666L11.0075 5.17416M1.75 10.0625V12.25H3.9375L10.3892 5.79249L8.20167 3.60499L1.75 10.0625Z"
                    fill="#1B1D21"
                  />
                </svg>
                개인정보 수정
              </button>
            </template>

            <template #default="{ close }">
              <div
                class="bg-black bg-opacity-25 w-screen h-screen flex justify-center items-center"
              >
                <div
                  class="min-w-[25vw] flex flex-col bg-white w-fit rounded-3xl"
                >
                  <button
                    aria-label="close"
                    class="my-dialog__close w-fit mt-3 mr-4 self-end"
                    @click="close"
                  >
                    <h4 class="text-2xl">
                      <font-awesome-icon icon="fa-solid fa-circle-xmark" />
                    </h4>
                  </button>
                  <MemberProfilePage />
                </div>
              </div>
            </template>
          </VDialog>

          <button
            type="button"
            class="inline-flex h-fit gap-1 bg-white border text-neutral-400 p-2 items-center text-sm"
            @click="logout()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M9.91699 4.08333L9.09449 4.90583L10.5995 6.41667H4.66699V7.58333H10.5995L9.09449 9.08833L9.91699 9.91667L12.8337 7M2.33366 2.91667H7.00033V1.75H2.33366C1.69199 1.75 1.16699 2.275 1.16699 2.91667V11.0833C1.16699 11.725 1.69199 12.25 2.33366 12.25H7.00033V11.0833H2.33366V2.91667Z"
                fill="#898C92"
              />
            </svg>
            로그아웃
          </button>
        </div>
      </div>
    </div>

    <!-- 하나바이블 부서 / 학기,과정 / 과 수정 부분-->
    <div class="flex flex-col items-center justify-center gap-4 my-14">
      <h2 class="text-2xl font-semibold mb-3">하나바이블 설정</h2>
      <p class="text-sm text-gray-500 mb-4 text-center break-keep">
        회원님께서 입력해주신 부서와 교육 과정 정보를 바탕으로, 콘텐츠몰의
        스마트 추천 영역에는 회원님께 가장 필요하고 적합한 콘텐츠만 모아
        보여드리고 있습니다.
      </p>
      <div
        class="flex items-center justify-center max-md:flex-col gap-y-2 w-full"
      >
        <ul
          class="w-[40rem] max-w-full md:max-w-[92%] flex max-md:flex-col items-center justify-center gap-2 px-2"
        >
          <!-- 부서 선택 -->
          <li class="relative w-full">
            <button
              @click="isDepartmentPopoverOpen = !isDepartmentPopoverOpen"
              :class="[
                'w-full flex items-center justify-center gap-x-2 border border-neutral-100 px-3 py-1.5 rounded-full hover:bg-white transition-colors max-md:text-sm whitespace-nowrap',
                selectedCategory
                  ? 'border-blue-500 text-blue-600 font-semibold bg-blue-50'
                  : 'bg-neutral-100 text-neutral-700',
              ]"
            >
              {{
                selectedCategory
                  ? getCategoryLabel(selectedCategory)
                  : "1. 부서 선택"
              }}
              <svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{ 'rotate-180': isDepartmentPopoverOpen }"
              >
                <path
                  d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z"
                  fill="currentColor"
                />
              </svg>
            </button>

            <div v-if="isDepartmentPopoverOpen" class="popover_container">
              <b class="md:hidden text-lg font-semibold mb-3">부서 선택</b>
              <button
                @click="isDepartmentPopoverOpen = false"
                class="absolute top-4 md:top-2 right-4 md:right-3 p-1 z-10"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
              <div class="relative py-1 flex flex-col w-full">
                <!-- 카테고리 섹션 -->
                <div class="flex-grow flex-shrink-0">
                  <label
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      value=""
                      v-model="selectedCategory"
                      class="mr-2"
                      @change="handleListChange"
                    />
                    선택 안 함
                  </label>
                  <label
                    v-for="category in groups"
                    :key="category.value"
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      :value="category.value"
                      v-model="selectedCategory"
                      class="mr-2"
                      @change="handleListChange"
                    />
                    {{ category.label }}
                  </label>
                </div>
              </div>
            </div>
          </li>

          <!-- 학기,과정 선택 -->
          <li class="relative w-full">
            <button
              @click="isSemesterPopoverOpen = !isSemesterPopoverOpen"
              :class="[
                'w-full flex items-center justify-center gap-x-2 border border-neutral-100 px-3 py-1.5 rounded-full hover:bg-white transition-colors max-md:text-sm whitespace-nowrap',
                selectedSemester
                  ? 'border-blue-500 text-blue-600 font-semibold bg-blue-50'
                  : 'bg-neutral-100 text-neutral-700',
              ]"
            >
              {{
                selectedSemester
                  ? getSemesterLabel(selectedSemester)
                  : "2. 학기/과정 선택"
              }}
              <svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{ 'rotate-180': isSemesterPopoverOpen }"
              >
                <path
                  d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z"
                  fill="currentColor"
                />
              </svg>
            </button>

            <div v-if="isSemesterPopoverOpen" class="popover_container">
              <b class="md:hidden text-lg font-semibold mb-3">학기/과정 선택</b>
              <button
                @click="isSemesterPopoverOpen = false"
                class="absolute top-4 md:top-2 right-4 md:right-3 p-1 z-10"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                    fill="black"
                  />
                </svg>
              </button>
              <div
                class="relative py-1 flex flex-col w-full h-full overflow-auto"
              >
                <!-- 카테고리 섹션 -->
                <div
                  class="flex-grow flex-shrink-0 max-h-screen md:max-h-[30vh] overflow-auto"
                >
                  <label
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      value=""
                      v-model="selectedSemester"
                      class="mr-2"
                      @change="handleSemesterChange"
                    />
                    선택 안 함
                  </label>
                  <label
                    v-for="semester in semesters"
                    :key="semester.value"
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      :value="semester.value"
                      v-model="selectedSemester"
                      class="mr-2"
                      @change="handleSemesterChange"
                    />
                    {{ semester.label }}
                  </label>
                </div>
              </div>
            </div>
          </li>

          <!-- 과 선택 -->
          <li class="relative w-full">
            <button
              @click="isChapterPopoverOpen = !isChapterPopoverOpen"
              :class="[
                'w-full flex items-center justify-center gap-x-2 border border-neutral-100 px-3 py-1.5 rounded-full hover:bg-white transition-colors max-md:text-sm whitespace-nowrap',
                selectedLesson
                  ? 'border-blue-500 text-blue-600 font-semibold bg-blue-50'
                  : 'bg-neutral-100 text-neutral-700',
              ]"
            >
              {{
                selectedLesson ? getChapterLabel(selectedLesson) : "3. 과 선택"
              }}
              <svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{ 'rotate-180': isChapterPopoverOpen }"
              >
                <path
                  d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z"
                  fill="black"
                />
              </svg>
            </button>

            <div v-if="isChapterPopoverOpen" class="popover_container">
              <b class="md:hidden text-lg font-semibold mb-3">과 선택</b>
              <button
                @click="isChapterPopoverOpen = false"
                class="absolute top-4 md:top-2 right-4 md:right-3 p-1 z-10"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                    fill="black"
                  />
                </svg>
              </button>

              <div
                class="relative py-1 flex w-full h-full overflow-auto max-md:pb-5"
              >
                <!-- 카테고리 섹션 -->
                <div
                  class="flex-grow flex-shrink-0 max-h-screen md:max-h-[30vh] overflow-auto"
                >
                  <label
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      value=""
                      v-model="selectedLesson"
                      class="mr-2"
                      @change="handleListChange"
                    />
                    선택 안 함
                  </label>
                  <label
                    v-for="chapter in filteredLessons"
                    :key="chapter.value"
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      :value="chapter.value"
                      v-model="selectedLesson"
                      class="mr-2"
                      @change="handleListChange"
                    />
                    {{ chapter.label }}
                  </label>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!-- 저장 : 비회원은 이용 불가 -->
        <button
          v-if="$store.state.uid.id"
          class="group flex items-center self-end text-sm bg-neutral-800 text-neutral-100 rounded-full px-3 py-2 whitespace-nowrap max-md:mr-2"
          @click="putPreference"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 3.11111V12.4444C14 12.8722 13.8478 13.2386 13.5434 13.5434C13.2391 13.8483 12.8727 14.0005 12.4444 14H1.55556C1.12778 14 0.761704 13.8478 0.457333 13.5434C0.152963 13.2391 0.000518519 12.8727 0 12.4444V1.55556C0 1.12778 0.152445 0.761704 0.457333 0.457333C0.762222 0.152963 1.1283 0.000518518 1.55556 0H10.8889L14 3.11111ZM7 11.6667C7.64815 11.6667 8.19907 11.4398 8.65278 10.9861C9.10648 10.5324 9.33333 9.98148 9.33333 9.33333C9.33333 8.68518 9.10648 8.13426 8.65278 7.68055C8.19907 7.22685 7.64815 7 7 7C6.35185 7 5.80093 7.22685 5.34722 7.68055C4.89352 8.13426 4.66667 8.68518 4.66667 9.33333C4.66667 9.98148 4.89352 10.5324 5.34722 10.9861C5.80093 11.4398 6.35185 11.6667 7 11.6667ZM2.33333 5.44444H9.33333V2.33333H2.33333V5.44444Z"
              fill="currentColor"
            />
          </svg>

          <p
            class="md:opacity-0 md:max-w-0 overflow-hidden transition-all duration-700 ease-in-out group-hover:opacity-100 group-hover:max-w-[200px]"
          >
            &nbsp;설정 저장하기
          </p>
        </button>
      </div>
    </div>

    <div
      class="w-full flex justify-between gap-[1.6vw] my-7 max-md:flex-col max-md:px-5"
    >
      <section
        class="w-full border border-neutral-200 rounded-lg p-[1.6vw] max-md:p-5"
      >
        <h3 class="mb-7">접수·결제 정보</h3>
        <div class="flex flex-col w-fit gap-1 text-neutral-600">
          <router-link to="/profile/confList" target="_blank" c
            >컨퍼런스 신청내역</router-link
          >
          <router-link to="/mypage/list">주문내역</router-link>
          <router-link to="/mypage/paymentList">결제내역</router-link>
        </div>
      </section>
      <section
        class="w-full border border-neutral-200 rounded-lg p-[1.6vw] max-md:p-5"
      >
        <h3 class="mb-7">내 콘텐츠</h3>
        <div class="flex flex-col w-fit gap-1 text-neutral-600">
          <!-- <router-link to="">온라인 강의실</router-link> -->
          <router-link to="/mypage/contentsBox">콘텐츠 보관함</router-link>
          <router-link to="/mypage/downloadHistory"
            >콘텐츠 다운로드 내역</router-link
          >
          <router-link to="/mypage/cart">콘텐츠 장바구니</router-link>
        </div>
      </section>
      <section
        class="w-full border border-neutral-200 rounded-lg p-[1.6vw] max-md:p-5"
      >
        <h3 class="mb-7">작성한 글</h3>
        <div class="flex flex-col w-fit gap-1 text-neutral-600">
          <router-link to="/mypage/post">내가 작성한 글</router-link>
          <!-- <router-link to="">나의 문의내역</router-link> -->
          <router-link to="/mypage/review">나의 후기</router-link>
        </div>
      </section>
    </div>

    <!-- <div class="flex flex-col mt-20 max-lg:px-5 max-lg:mt-12">
      <h3 class="font-bold">나의 최근 결제 내역</h3>
      <div class="table_grid_container">
        <table class="table_grid_wrapper">
          <tr class="table_grid_header">
            <th>구분</th>
            <th>주문번호</th>
            <th>주문명</th>
            <th>주문일자</th>
            <th>결제금액</th>
            <th>결제수단</th>
            <th>결제상태</th>
            <th>영수증</th>
          </tr>
          <tr class="table_grid_body">
            <td>콘텐츠</td>
            <td>230808101615317854</td>
            <td>{{ truncateText() }}</td>
            <td>23.06.14 15:41</td>
            <td>34,000원</td>
            <td>무통장 입금</td>
            <td>결제 완료</td>
            <td>
              <button type="button">영수증 출력</button>
            </td>
          </tr>
        </table>
      </div>
      
      <button class="w-1/6 max-lg:w-1/3 border border-neutral-300 text-neutral-400 p-2 text-sm mx-auto">
        더보기
      </button>
    </div> -->
  </main>
</template>

<script setup>
import store from "@/store";
import router from "@/router";
import { VDialog } from "vuetensils/src/components";
import { ref, onMounted, computed } from "vue";
import axios from "axios";

import MemberProfilePage from "@/pages/MemberProfilePage.vue";

const orderTitle = "하나바이블 3과정 1학기 2022 총회 구역예배 인도자 강의";
const maxLength = 25;

const truncateText = () => {
  return orderTitle.length > maxLength
    ? orderTitle.substring(0, maxLength) + "..."
    : orderTitle;
};

const logout = () => {
  localStorage.removeItem("authorization");
  store.commit("setAccount", 0);
  store.commit("setLevel", 0);
  store.commit("setUid", "");
  router.push({ path: "/" });
};

// 하나바이블 설정 관련 로직
const isDepartmentPopoverOpen = ref(false);
const isSemesterPopoverOpen = ref(false);
const isChapterPopoverOpen = ref(false);

const selectedCategory = ref("");
const selectedSemester = ref("");
const selectedLesson = ref("");

const groups = [
  { label: "영유아부", value: "INFANT" },
  { label: "유치부", value: "KINDERGARTEN" },
  { label: "유년부", value: "CHILD" },
  { label: "초등부", value: "ELEMENTARY" },
  { label: "청소년", value: "TEENAGER" },
  { label: "대학 및 청년부", value: "ADULT" },
];

const semesters = [
  { label: "1과정1학기", value: "1-1", group: "1" },
  { label: "1과정2학기", value: "1-2", group: "2" },
  { label: "2과정1학기", value: "2-1", group: "1" },
  { label: "2과정2학기", value: "2-2", group: "2" },
  { label: "3과정1학기", value: "3-1", group: "1" },
  { label: "3과정2학기", value: "3-2", group: "2" },
  { label: "4과정1학기", value: "4-1", group: "1" },
  { label: "4과정2학기", value: "4-2", group: "2" },
  { label: "5과정1학기", value: "5-1", group: "1" },
  { label: "5과정2학기", value: "5-2", group: "2" },
  { label: "6과정1학기", value: "6-1", group: "1" },
  { label: "6과정2학기", value: "6-2", group: "2" },
];

const lessons = [
  { label: "1과", value: "1", group: "1" },
  { label: "2과", value: "2", group: "1" },
  { label: "3과", value: "3", group: "1" },
  { label: "4과", value: "4", group: "1" },
  { label: "5과", value: "5", group: "1" },
  { label: "6과", value: "6", group: "1" },
  { label: "7과", value: "7", group: "1" },
  { label: "8과", value: "8", group: "1" },
  { label: "9과", value: "9", group: "1" },
  { label: "10과", value: "10", group: "1" },
  { label: "11과", value: "11", group: "1" },
  { label: "12과", value: "12", group: "1" },
  { label: "13과", value: "13", group: "1" },
  { label: "14과", value: "14", group: "1" },
  { label: "15과", value: "15", group: "1" },
  { label: "16과", value: "16", group: "1" },
  { label: "17과", value: "17", group: "1" },
  { label: "18과", value: "18", group: "1" },
  { label: "19과", value: "19", group: "1" },
  { label: "20과", value: "20", group: "1" },
  { label: "21과", value: "21", group: "1" },
  { label: "22과", value: "22", group: "1" },

  { label: "23과", value: "23", group: "2" },
  { label: "24과", value: "24", group: "2" },
  { label: "25과", value: "25", group: "2" },
  { label: "26과", value: "26", group: "2" },
  { label: "27과", value: "27", group: "2" },
  { label: "28과", value: "28", group: "2" },
  { label: "29과", value: "29", group: "2" },
  { label: "30과", value: "30", group: "2" },
  { label: "31과", value: "31", group: "2" },
  { label: "32과", value: "32", group: "2" },
  { label: "33과", value: "33", group: "2" },
  { label: "34과", value: "34", group: "2" },
  { label: "35과", value: "35", group: "2" },
  { label: "36과", value: "36", group: "2" },
  { label: "37과", value: "37", group: "2" },
  { label: "38과", value: "38", group: "2" },
  { label: "39과", value: "39", group: "2" },
  { label: "40과", value: "40", group: "2" },
  { label: "41과", value: "41", group: "2" },
  { label: "42과", value: "42", group: "2" },
  { label: "43과", value: "43", group: "2" },
  { label: "44과", value: "44", group: "2" },

  { label: "어버이주일", value: "어버이주일", group: "3" },
  { label: "어린이주일", value: "어린이주일", group: "3" },
  { label: "부활주일", value: "부활주일", group: "3" },
  { label: "종려주일", value: "종려주일", group: "3" },
  { label: "성탄주일", value: "성탄주일", group: "3" },
  { label: "추수감사", value: "추수감사", group: "3" },
  { label: "전도선교", value: "전도선교", group: "3" },
  { label: "이단경계", value: "이단경계", group: "3" },
  { label: "이웃사랑", value: "이웃사랑", group: "3" },
  { label: "나라사랑", value: "나라사랑", group: "3" },
  { label: "공통", value: "공통", group: "3" },
];

const filteredLessons = computed(() => {
  const currentSemester = semesters.find(
    (s) => s.value === selectedSemester.value
  );

  if (!currentSemester) {
    // 학기가 선택되지 않았거나 찾을 수 없는 경우 전체 노출 (또는 정책에 따라 빈 배열)
    // 여기서는 전체 노출로 둡니다.
    return lessons;
  }

  const group = currentSemester.group;

  if (group === "1") {
    return lessons.filter((l) => l.group === "1" || l.group === "3");
  } else if (group === "2") {
    return lessons.filter((l) => l.group === "2" || l.group === "3");
  } else if (group === "3") {
    return lessons.filter((l) => l.group === "3");
  }

  return lessons;
});

const getCategoryLabel = (value) => {
  const category = groups.find((c) => c.value === value);
  return category ? category.label : "";
};

const getSemesterLabel = (value) => {
  const semester = semesters.find((s) => s.value === value);
  return semester ? semester.label : "";
};

const getChapterLabel = (value) => {
  const chapter = lessons.find((c) => c.value === value);
  return chapter ? chapter.label : "";
};

const handleSemesterChange = () => {
  selectedLesson.value = "";
  handleListChange();
};

const handleListChange = () => {
  isDepartmentPopoverOpen.value = false;
  isSemesterPopoverOpen.value = false;
  isChapterPopoverOpen.value = false;
};

const putPreference = async () => {
  if (
    selectedCategory.value ||
    selectedSemester.value ||
    selectedLesson.value
  ) {
    const preferenceValue =
      selectedCategory.value +
      ":" +
      selectedSemester.value +
      ":" +
      selectedLesson.value;

    try {
      axios
        .put("/new_api/account/hana-bible-preference", {
          hanaBiblePreference: preferenceValue,
        })
        .then((res) => {
          alert("설정이 저장되었습니다.");
        });
    } catch (error) {
      console.error(error);
    }
  } else {
    alert("부서, 학기/과정, 과를 선택해 주세요.");
    return;
  }
};

const getPreference = async () => {
  try {
    const res = await axios.get(`/new_api/account/hana-bible-preference`);
    const rawPreference = res.data.data.hanaBiblePreference;

    if (rawPreference) {
      const parts = rawPreference.split(":");

      selectedCategory.value = parts[0] || "";
      selectedSemester.value = parts[1] || "";
      selectedLesson.value = parts[2] || "";
    }
  } catch (error) {
    console.error(error);
  }
};

onMounted(async () => {
  await getPreference();
});
</script>
